import { defineMessage } from "react-intl";
import type { FigureMetadata } from "../components/figure";

export const metadata: FigureMetadata = {
  id: "OVERAGE",
  title: defineMessage({
    id: "fig.access.OVERAGE.title",
    defaultMessage: `Over-age attendance is an important challenge in many countries`,
  }),
  caption: defineMessage({
    id: "fig.access.OVERAGE.caption",
    defaultMessage: `School participation by age and level`,
  }),
  source: defineMessage({
    id: "fig.access.OVERAGE.source",
    defaultMessage: `GEM Report team analysis using DHS and MICS data`,
  }),
};
